import { useState } from 'react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const TestScanner = () => {
  const [qrInput, setQrInput] = useState('');
  const [result, setResult] = useState(null);
  const [allVisitors, setAllVisitors] = useState([]);

  const handleTest = async () => {
    console.log('🔍 Testing QR:', qrInput);
    try {
      const response = await axios.post(`${API}/visitors/validate`, {
        qr_code: qrInput.trim(),
        scanned_by: 'Test Manual'
      });
      
      setResult(response.data);
      console.log('✅ Response:', response.data);
    } catch (error) {
      console.error('❌ Error:', error);
      setResult({ success: false, message: error.message });
    }
  };

  const loadVisitors = async () => {
    try {
      // Login first
      const loginResponse = await axios.post(`${API}/auth/login`, {
        username: 'carlos.loreto',
        password: '252577'
      });
      
      const token = loginResponse.data.access_token;
      
      const response = await axios.get(`${API}/visitors`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      
      setAllVisitors(response.data);
    } catch (error) {
      console.error('Error loading visitors:', error);
    }
  };

  const testVisitor = async (qrCode) => {
    setQrInput(qrCode);
    try {
      const response = await axios.post(`${API}/visitors/validate`, {
        qr_code: qrCode,
        scanned_by: 'Test Manual'
      });
      
      setResult(response.data);
      alert(`Result: ${response.data.success ? 'SUCCESS' : 'FAILED'}\nMessage: ${response.data.message}`);
    } catch (error) {
      alert(`Error: ${error.message}`);
    }
  };

  return (
    <div style={{ padding: '2rem', maxWidth: '1200px', margin: '0 auto' }}>
      <h1>🔍 Test Scanner de QR - Debug</h1>
      
      <div style={{ background: '#f7fafc', padding: '1.5rem', borderRadius: '8px', marginBottom: '2rem' }}>
        <h2>Test Manual</h2>
        <input
          type="text"
          value={qrInput}
          onChange={(e) => setQrInput(e.target.value)}
          placeholder="Pega el UUID del QR aquí"
          style={{
            width: '100%',
            padding: '0.75rem',
            fontSize: '1rem',
            border: '2px solid #cbd5e0',
            borderRadius: '8px',
            marginBottom: '1rem',
            fontFamily: 'monospace'
          }}
        />
        <button
          onClick={handleTest}
          style={{
            padding: '0.75rem 2rem',
            background: '#667eea',
            color: 'white',
            border: 'none',
            borderRadius: '8px',
            cursor: 'pointer',
            fontSize: '1rem'
          }}
        >
          Probar QR
        </button>
        
        {result && (
          <div style={{
            marginTop: '1rem',
            padding: '1rem',
            background: result.success ? '#d1fae5' : '#fee2e2',
            border: `2px solid ${result.success ? '#065f46' : '#991b1b'}`,
            borderRadius: '8px'
          }}>
            <h3>{result.success ? '✅ Válido' : '❌ Inválido'}</h3>
            <p><strong>Mensaje:</strong> {result.message}</p>
            {result.visitor && (
              <div>
                <p><strong>Nombre:</strong> {result.visitor.name}</p>
                <p><strong>Status:</strong> {result.visitor.status}</p>
              </div>
            )}
          </div>
        )}
      </div>

      <div style={{ background: '#fff', padding: '1.5rem', borderRadius: '8px' }}>
        <h2>Visitantes Disponibles</h2>
        <button
          onClick={loadVisitors}
          style={{
            padding: '0.5rem 1rem',
            background: '#4299e1',
            color: 'white',
            border: 'none',
            borderRadius: '8px',
            cursor: 'pointer',
            marginBottom: '1rem'
          }}
        >
          Cargar Visitantes
        </button>
        
        {allVisitors.length > 0 && (
          <table style={{ width: '100%', borderCollapse: 'collapse' }}>
            <thead>
              <tr style={{ background: '#edf2f7' }}>
                <th style={{ padding: '0.75rem', textAlign: 'left', border: '1px solid #cbd5e0' }}>Nombre</th>
                <th style={{ padding: '0.75rem', textAlign: 'left', border: '1px solid #cbd5e0' }}>Status</th>
                <th style={{ padding: '0.75rem', textAlign: 'left', border: '1px solid #cbd5e0' }}>QR Code</th>
                <th style={{ padding: '0.75rem', textAlign: 'left', border: '1px solid #cbd5e0' }}>Acción</th>
              </tr>
            </thead>
            <tbody>
              {allVisitors.map(v => (
                <tr key={v.id}>
                  <td style={{ padding: '0.75rem', border: '1px solid #cbd5e0' }}>{v.name}</td>
                  <td style={{ padding: '0.75rem', border: '1px solid #cbd5e0' }}>
                    <span style={{
                      padding: '0.25rem 0.75rem',
                      background: v.status === 'pending' ? '#fef3c7' : '#d1fae5',
                      color: v.status === 'pending' ? '#92400e' : '#065f46',
                      borderRadius: '4px',
                      fontSize: '0.875rem'
                    }}>
                      {v.status}
                    </span>
                  </td>
                  <td style={{ padding: '0.75rem', border: '1px solid #cbd5e0', fontFamily: 'monospace', fontSize: '0.75rem' }}>
                    {v.qr_code}
                  </td>
                  <td style={{ padding: '0.75rem', border: '1px solid #cbd5e0' }}>
                    <button
                      onClick={() => testVisitor(v.qr_code)}
                      style={{
                        padding: '0.5rem 1rem',
                        background: '#48bb78',
                        color: 'white',
                        border: 'none',
                        borderRadius: '4px',
                        cursor: 'pointer',
                        fontSize: '0.875rem'
                      }}
                    >
                      Probar
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
};

export default TestScanner;
